import React from 'react';


class LodingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingCircles: []
    };
  }

  // Lifecycle method to create loading circles when the component mounts

  componentDidMount() {
    // Create an array of loading circle elements
    const loadingCircles = [];
    for (let i = 0; i < 42; i++) {
      loadingCircles.push(<div key={i} className="loading-circle"></div>);
    }

    // Set the state with the loading circles
    this.setState({ loadingCircles });
  }

  render() {
    return (
      <div id="loading">
        <div id="loading-text">Loading...</div>    
        {this.state.loadingCircles}
      </div>
    );
  }
}

export default LodingComponent;
